// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from 'E:/jenkins/jenkins_home/workspace/cn_ragflow_web/node_modules/.pnpm/@umijs+renderer-react@4.6.3_a7957afd112982726b76831afc1c48bc/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
